/* src/app/modules/product-labels/labels-picker/labels-picker.component.scss */
.bs-light {
  font-family: poppins, sans-serif;
  font-weight: 300;
  font-style: normal;
}
.bs-italic {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: italic;
}
.bs-regular,
.label-picker-info-text {
  font-family: poppins, sans-serif;
  font-weight: 400;
  font-style: normal;
}
.bs-medium {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: normal;
}
.bs-medium-italic {
  font-family: poppins, sans-serif;
  font-weight: 500;
  font-style: italic;
}
.bs-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: italic;
}
.bs-semi-bold {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: normal;
}
.bs-semi-bold-italic {
  font-family: poppins, sans-serif;
  font-weight: 600;
  font-style: italic;
}
.bs-bold,
.label-picker-title,
.label-picker-subtitle {
  font-family: poppins, sans-serif;
  font-weight: 700;
  font-style: normal;
}
.f12px {
  font-size: 0.75rem;
}
.f14px {
  font-size: 0.875rem;
}
.f16px {
  font-size: 1rem;
}
.f18px {
  font-size: 1.125rem;
}
.f20px {
  font-size: 1.25rem;
}
.f24px {
  font-size: 1.5rem;
}
.f32px {
  font-size: 2rem;
}
.f48px {
  font-size: 3rem;
}
.label-picker-title {
  display: block;
  font-size: 1rem;
  color: #222222;
}
.label-picker-subtitle {
  display: block;
  font-size: 0.75rem;
  color: #222222;
  margin-bottom: 1rem;
}
.label-picker-info-text {
  display: block;
  font-size: 0.65rem;
  color: #222222;
}
.edit-company-label {
  position: absolute;
  left: 0.75rem;
}
.radio-divider {
  background-color: #dadbde;
}
.clear-labels-button {
  position: absolute;
  left: 0.75rem;
  top: 0;
}
.button-row {
  padding-top: 3rem;
}
.selection-container {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 1rem;
}
.divider-block {
  display: block;
  width: 100%;
}
/*# sourceMappingURL=labels-picker.component.css.map */
